import LoadingButton from "@mui/lab/LoadingButton"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import { useEffect } from "react"

import { useAuthorizedAxiosClient } from "../../../../common/axios"
import DialogHeader from "../../components/DialogHeader"
import {
  CreateWorkflowDialogContent,
  useCreateWorkflowState,
} from "../list/CreateWorkflowDialog"

export default function EditWorkflowDialog({
  open,
  onClose,
  workflow,
  isLoading: isWorkflowLoading,
}) {
  const {
    name,
    setName,
    description,
    setDescription,
    isLoading,
    setIsLoading,
    disableSubmit,
  } = useCreateWorkflowState()
  const axios = useAuthorizedAxiosClient()

  function handleSoftClose() {
    onClose()
  }

  function handleSaveButtonClicked() {
    setIsLoading(true)
    axios
      .put(`/workflows/api/workflows/${workflow.id}/`, {
        ...workflow,
        name,
        description,
      })
      .then(({ data }) => onClose(data))
      .finally(() => setIsLoading(false))
  }

  useEffect(
    () => {
      if (isWorkflowLoading) {
        return
      }
      setName(workflow.name)
      setDescription(workflow.description)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isWorkflowLoading]
  )

  return (
    <Dialog open={open} onClose={handleSoftClose} maxWidth="sm" fullWidth>
      <DialogHeader title="Edit Workflow" onClose={handleSoftClose} />
      <CreateWorkflowDialogContent
        name={name}
        setName={setName}
        description={description}
        setDescription={setDescription}
      />
      <DialogActions>
        <Button variant="outlined" color="inherit" onClick={handleSoftClose}>
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          color="primary"
          loading={isLoading}
          disabled={disableSubmit}
          onClick={handleSaveButtonClicked}
        >
          Save
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}
